import { render, staticRenderFns } from "./StudioPerf.vue?vue&type=template&id=ff1e39ca&scoped=true&"
import script from "./StudioPerf.vue?vue&type=script&lang=js&"
export * from "./StudioPerf.vue?vue&type=script&lang=js&"
import style0 from "./StudioPerf.vue?vue&type=style&index=0&id=ff1e39ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1e39ca",
  null
  
)

export default component.exports